<app-header></app-header>
<ion-content [scrollEvents]="false" *ngIf="!!product">
  <section class="write-a-review-content">
    <ion-grid [fixed]="true">
      <ion-row class="breadcrumbs-container">
        <ion-col>
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"> </app-breadcrumbs>
        </ion-col>
      </ion-row>
      <h1 class="page-title-oswald">{{title | translate }}</h1>
      <div *ngIf="!!subtitle" class="review-products-subtitle">
        {{subtitle | translate }}
      </div>
    </ion-grid>
    <app-product-header-card [product]="product"></app-product-header-card>
    <div id="pwr-write-review" data-cy="pwr-write-review"></div>
    <div id="pwr-ask-a-question" data-cy="pwr-ask-a-question"></div>
  </section>
  <app-footer></app-footer>
</ion-content>
